import restApi from "@plannel/services/utils/rest-api";

/**
 * Version Notes(S&OP) API — 모듈과 버전을 가로질러 노트를 읽는다.
 *
 * 응답: { result: VersionNoteDto[], moduleCds: ["DP","RP","MP"] }
 *   moduleCds 는 이 사용자가 볼 수 있는 모듈(노트가 0건이어도 들어 있다).
 * 노트 작성 · 삭제는 여기가 아니라 dp-note-service / note-service 가 한다.
 *
 * @param {object} search { moduleCds?, planVersionId?, updatedFrom? }
 */
const list = (search) => restApi.post("/api/version-notes", search);

const versionNoteService = { list };

export default versionNoteService;
